// extracted by mini-css-extract-plugin
export default {"discoverFauxBtn":"discover-button_discoverFauxBtn__abDHw","wipeDown":"discover-button_wipeDown__3lj16","bounceButton":"discover-button_bounceButton__X0WXY"};